export default function Logo({ className = '' }: { className?: string }) {
	return <img src="image/FL_logo_main_blue.svg" className={`h-auto max-w-full ${className}`} alt="FutureLab" />;
}
